// Progresso por aula pode ser:
// - `true`: aula legada marcada como concluida por inteiro (sem blocos);
// - `{ [guiaId]: boolean }`: progresso por bloco (Resumo/QF/QA/FH/Mapa etc).

export function isGuiaConcluida(progress, aulaId, guiaId) {
  const valor = progress?.[aulaId];
  if (valor === true) return true;
  if (valor && typeof valor === "object") return Boolean(valor[guiaId]);
  return false;
}

export function isAulaConcluida(progress, aula) {
  const valor = progress?.[aula.id];
  if (valor === true) return true;

  if (!aula.guias?.length) {
    return false;
  }

  if (!valor || typeof valor !== "object") {
    return false;
  }

  return aula.guias.every((guia) => Boolean(valor[guia.id]));
}

export function toggleAulaProgress(progress, aula, guiaId) {
  const atual = progress?.[aula.id];

  if (!guiaId) {
    return !isAulaConcluida(progress, aula);
  }

  const baseGuias =
    atual === true
      ? Object.fromEntries((aula.guias || []).map((guia) => [guia.id, true]))
      : atual && typeof atual === "object"
        ? atual
        : {};

  return {
    ...baseGuias,
    [guiaId]: !baseGuias[guiaId],
  };
}
